import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { enUS } from 'date-fns/locale';
import { isToday, format } from 'date-fns';
import { DatePicker } from 'react-nice-dates';
// special scss file that imports react-nice-dates styles with color overrides
import '../../../../styles/global/react-datepicker.scss';

import CartCheckbox from '../CartCheckbox/CartCheckbox';
import { IconInfo } from '../Icons';
import { getDatePickerFormat, getPlusReleaseDateFormat, getExcludedDates, getMinDate, getMaxDate } from '../../Utils/DateUtils';

import { StyledWrapper, StyledTooltip, StyledTooltipText } from './PlusReleaseDateStyles';

var _ref = React.createElement(IconInfo, null);

var PlusReleaseDate = function PlusReleaseDate(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      date = _useState4[0],
      setDate = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      tooltipActive = _useState6[0],
      setTooltipActive = _useState6[1];

  var addPlusReleaseDate = props.addPlusReleaseDate;


  var removeDate = useCallback(function () {
    // remove local storage and set date to null
    localStorage.removeItem('dormify_checkout_plus_release');
    setDate(null);
    addPlusReleaseDate(null);
  }, [setDate, addPlusReleaseDate]);

  var handleCheckboxChange = function handleCheckboxChange() {
    if (active === true && date != null) {
      // remove date state too
      removeDate();
    }
    setActive(!active);
  };

  useEffect(function () {
    var localStorageDate = null;
    if (props.checkoutCustomAttributes) {
      localStorageDate = props.checkoutCustomAttributes.find(function (item) {
        if (item.key === 'release_date') {
          return item.value;
        }
      });
    }
    if (localStorageDate) {
      // set date and active
      setDate(getDatePickerFormat(localStorageDate));
      setActive(true);
    }
    // Prevent date updates from rerunning effect. only care about local storage
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.checkoutCustomAttributes.length]);

  useEffect(function () {
    if (!props.noVendorItems) {
      // if vendor items, remove date, deactivate, disable
      removeDate();
      setActive(false);
    }
  }, [props.noVendorItems, removeDate]);

  var _ref2 = React.createElement(
    StyledTooltipText,
    { tooltipActive: tooltipActive },
    'Keep in mind that you are selecting the date when your order will SHIP, not the date that it will be delivered. You should factor in additional delivery time for your order which can be found on our Shipping Policies page. Due to variability in shipping time, we cannot GUARANTEE exact delivery dates. Ship dates are not available on weekends and holidays.'
  );

  var ToolTip = function ToolTip() {
    return React.createElement(
      StyledTooltip,
      {
        onMouseOver: function onMouseOver() {
          return setTooltipActive(true);
        },
        onFocus: function onFocus() {
          return setTooltipActive(true);
        },
        onMouseOut: function onMouseOut() {
          return setTooltipActive(false);
        },
        onBlur: function onBlur() {
          return setTooltipActive(false);
        }
      },
      _ref,
      _ref2
    );
  };

  return React.createElement(
    StyledWrapper,
    { disabled: !props.noVendorItems },
    React.createElement(
      CartCheckbox,
      {
        toolTip: React.createElement(ToolTip, null),
        text: 'Buy Now, Ship Later',
        checked: active,
        disabled: !props.noVendorItems,
        onChange: handleCheckboxChange,
        maxHeight: '40px'
      },
      React.createElement(
        DatePicker,
        {
          date: date,
          locale: enUS,
          onDateChange: function onDateChange(newDate) {
            if (newDate) {
              setDate(newDate);
              addPlusReleaseDate(getPlusReleaseDateFormat(newDate));
            }
          },
          format: 'MMMM d, yyyy',
          minimumDate: getMinDate(new Date()),
          maximumDate: getMaxDate(new Date()),
          modifiers: {
            disabled: function disabled(date) {
              return getExcludedDates(date);
            },
            today: function today(date) {
              return isToday(date) === true;
            }
          },
          modifiersClassNames: {
            today: '-today'
          }
        },
        function (_ref3) {
          var inputProps = _ref3.inputProps,
              focused = _ref3.focused;

          return React.createElement('input', Object.assign({}, inputProps, {
            className: 'input' + (focused ? ' -focused' : ''),
            placeholder: 'Select your ship date',
            readOnly: true,
            value: date ? format(date, 'MMMM d, yyyy') : ''
          }));
        }
      )
    )
  );
};

PlusReleaseDate.propTypes = {
  checkoutCustomAttributes: PropTypes.array,
  noVendorItems: PropTypes.bool,
  addPlusReleaseDate: PropTypes.func
};

export default PlusReleaseDate;